var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", { staticClass: "dashboard-block" }, [
    _c("h2", [_vm._v("Notify Others")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Add multiple email addresses in here to keep other stakeholders notified of any requests, separated by ';'"
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel panel-grey" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { class: ["form-group", _vm.errorClass("clubEmail")] }, [
            _c("label", { staticClass: "control-label sr-only" }, [
              _vm._v("Notify Others:"),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.$v.stateClubContact.$model,
                    expression: "$v.stateClubContact.$model",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  name: "email",
                  type: "email",
                  placeholder: "e.g. ea@agency.com; scheduling@sportsteam.com",
                },
                domProps: { value: _vm.$v.stateClubContact.$model },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.$v.stateClubContact,
                      "$model",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm.$v.stateClubContact.$error && _vm.submitted
                ? _c("p", { staticClass: "help-block pull-left" }, [
                    _vm._v(
                      "Each entry must be a valid email address, separated by ';'"
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-footer" },
        [
          _c(
            "ladda-button",
            {
              staticClass: "btn btn-sm btn-primary",
              attrs: {
                type: "submit",
                click: _vm.handleSaveClubContact,
                disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
              },
            },
            [_vm._v("\n        Save and Update\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }